function TimeLineItem({ period, role, company, description, technologies }) {
  return (
    <div className="timeline-item">
      <div className="timeline-dot"></div>
      <div className="timeline-title">{role}</div>

      <div className="timeline-date">{period}</div>

      <div className="timeline-company">{company}</div>

      <div className="timeline-desc">{description}</div>
    </div>
  );
}

export default TimeLineItem;
